import BaseAccordion from 'components/Accordions/BaseAccordion';
import { useGetDeviceTypeMapQuery } from 'services/devices/devices.api';
import DeviceGroupList from './DeviceGroupList';
import DeviceTypeList from './DeviceTypeList/DeviceTypeList';

const DeviceListAccordion = ({ showGroups, onOpenDevice, visibleDeviceTypes: visibleDeviceTypesProp, widget = false }) => {
  const { data: deviceTypes = [] } = useGetDeviceTypeMapQuery();

  if (showGroups) {
    return (
      <div className="d-block d-xl-none">
        {/* Mobile-only: accordion replaces the desktop table view. */}
        <BaseAccordion header="Groups" bodyBackground="#232B33">
          <DeviceGroupList
            onOpenDevice={onOpenDevice}
            visibleDeviceTypes={visibleDeviceTypesProp}
            widget={widget}
            deviceAccordion
          />
        </BaseAccordion>
      </div>
    );
  }

  return (
    <div className="d-block d-xl-none">
      {deviceTypes &&
        Array.isArray(deviceTypes) &&
        deviceTypes.map((dType) => (
          <DeviceTypeList
            key={dType.device_type}
            system={dType}
            systemName={dType.system_type}
            onOpenDevice={onOpenDevice}
            deviceAccordion
            widget={widget}
          />
        ))}
    </div>
  );
};

export default DeviceListAccordion;
